import React from 'react';
import { DefaultIcon, Clients as ClientIcon } from '../../../atoms/icons';
import './style.scss';
import Button from '../../buttons';

interface Props {
    id: string;
    icon?: React.ReactElement<DefaultIcon> | undefined;
    title: string;
    deviceId: string;
    location: string;
    configuration: string;
}

const VendingMachine: React.FC<Props> = (props) => {
  const {
    id, title, deviceId, location, configuration, icon = <ClientIcon width={16} />,
  } = props;
  return (
    <div id={id} className="card-vending-container">
      <div className="card-vending-content">
        <Button.CircleIcon
          id={id}
          isButton={false}
          className="card-vending-icon me-2"
          icon={icon}
        />
        <div className="fz-14">{title}</div>
      </div>
      <div className="w-100 bg-stroke my-2" style={{ height: '2px' }} />
      <div className="w-100 px-1 px-sm-2 px-xl-2">
        <table>
          <thead>
            <tr>
              <th style={{ maxWidth: '25%', width: '25%' }}>DEVICE ID</th>
              <th style={{ maxWidth: '40%', width: '40%' }}>LOCATION</th>
              <th style={{ maxWidth: '35%', width: '35%' }}>CONFIGURATION</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{deviceId}</td>
              <td><div>{location}</div></td>
              <td>{configuration}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};
export default VendingMachine;
